<template>
  <el-dialog
    center
    width="600px"
    title="编辑城市"
    :visible.sync="dialogFormVisible"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="名称" :label-width="formLabelWidth" prop="areaName">
        <el-input
          v-model="editForm.areaName"
          placeholder="请输入名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="拼音" :label-width="formLabelWidth" prop="pinyin">
        <el-input v-model="editForm.pinyin" placeholder="请输入拼音"></el-input>
      </el-form-item>

      <!-- <el-form-item label="邮编" :label-width="formLabelWidth" prop="areaCode">
        <el-input v-model="editForm.areaCode"  placeholder="请输入邮编"></el-input>
      </el-form-item> -->

      <el-form-item label="省份" :label-width="formLabelWidth" prop="pareaId">
        <el-cascader
          :options="areaAllList | filterList(areaAllList)"
          placeholder="请选择城市归属省份"
          v-model="editForm.pareaId"
          :label-width="formLabelWidth"
          :props="{ checkStrictly: true }"
          clearable
        >
        </el-cascader>
      </el-form-item>

      <!-- <div class="tooBox">
        <el-form-item label="经度" :label-width="formLabelWidth" prop="lng">
          <el-input v-model="editForm.lng"   placeholder="请输入经度"></el-input>
        </el-form-item>
        <el-form-item label="纬度" :label-width="formLabelWidth" prop="lat">
          <el-input v-model="editForm.lat"   placeholder="请输入纬度"></el-input>
        </el-form-item>
      </div> -->
      <div class="tooBox">
        <el-form-item
          label="是否热门"
          :label-width="formLabelWidth"
          prop="isHot"
        >
          <el-switch
            v-model="editForm.isHot"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        <el-form-item
          label="是否城市"
          :label-width="formLabelWidth"
          prop="city"
        >
          <el-switch
            v-model="editForm.isArea"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formRules } from '../form.js';
import { mapGetters } from 'vuex';
import { editFormApi } from '@/api/areaApi.js';
export default {
  name: 'editCity',
  data() {
    return {
      formLabelWidth: '122px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      editForm: {}, // 编辑表单数据
      editRules: formRules, // 表单的验证规则
      checkAreaLength: 0, // 选中编辑城市的长度，若大于1提示用户只能编辑一条
    };
  },
  computed: {
    ...mapGetters(['areaAllList', 'checkAreaListID']),
  },
  methods: {
    submitEdit() {
      try {
        if (this.checkAreaLength > 1)
          return this.$message.error('只能同时标记一条');
        if (this.editForm === {})
          return this.$message.error('请选择要编辑的对象');
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          const areaId = localStorage.getItem('areaId')
            ? JSON.parse(localStorage.getItem('areaId')).areaId
            : '';
          await editFormApi(this.editForm.areaId, { ...this.editForm, areaId });
          this.$message.success('修改成功!');
          this.dialogFormVisible = false;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" sconped>
.tooBox {
  display: flex;
}
</style>
